
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Dashboard from './pages/Dashboard';
import Prints from './pages/Prints';
import Media from './pages/Media';
import Artworks from './pages/Artworks';
import Activity from './pages/Activity';
import Login from './pages/Login';
import Providers from './pages/Providers';
import PrintProviders from './pages/PrintProviders';
import Creators from './pages/Creators';
import Certificates from './pages/Certificates';
import Digitization from './pages/Digitization';
import HologramGenerator from './pages/HologramGenerator';
import Templates from './pages/Templates';
import Collections from './pages/Collections';
import Currencies from './pages/Currencies';
import WebhookManagement from './pages/WebhookManagement';
import { Toaster } from "@/components/ui/toaster";

import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Index from './pages/Index';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login" element={<Login />} />
          
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/prints" element={<ProtectedRoute><Prints /></ProtectedRoute>} />
          <Route path="/media" element={<ProtectedRoute><Media /></ProtectedRoute>} />
          <Route path="/artworks" element={<ProtectedRoute><Artworks /></ProtectedRoute>} />
          <Route path="/activity" element={<ProtectedRoute><Activity /></ProtectedRoute>} />
          <Route path="/providers" element={<ProtectedRoute><Providers /></ProtectedRoute>} />
          <Route path="/print-providers" element={<ProtectedRoute><PrintProviders /></ProtectedRoute>} />
          <Route path="/creators" element={<ProtectedRoute><Creators /></ProtectedRoute>} />
          <Route path="/certificates" element={<ProtectedRoute><Certificates /></ProtectedRoute>} />
          <Route path="/digitization" element={<ProtectedRoute><Digitization /></ProtectedRoute>} />
          <Route path="/hologram-generator" element={<ProtectedRoute><HologramGenerator /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
          <Route path="/collections" element={<ProtectedRoute><Collections /></ProtectedRoute>} />
          <Route path="/currencies" element={<AdminRoute><Currencies /></AdminRoute>} />
          <Route path="/webhooks" element={<AdminRoute><WebhookManagement /></AdminRoute>} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
